import React, { useState } from 'react'
import { Button, CollapsibleHeader, FormGrid, Separator, Title } from '../../style'
import { Check, ChevronDown, ChevronUp } from 'lucide-react'
import { CardContent, CardTitle, CheckboxContainer, Input, InputContainer, InternalOrExternalCard, ItemContainer, Label } from './style'

const DeadlinesSection: React.FC = () => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(true)
  const [sections, setSections] = useState([
    {
      title: "Interno",
      items: [
        { id: "corte-serra-interno", label: "Corte serra", checked: true },
        { id: "outros-cortes-interno", label: "Outros cortes", checked: true },
        { id: "forja-interno", label: "Forja", checked: true },
        { id: "tt-interno", label: "TT", checked: false },
        { id: "usinagem-interno", label: "Usinagem", checked: true },
        { id: "ensaios-interno", label: "Ensaios", checked: false },
        { id: "entrega-interno", label: "Entrega", checked: true },
      ],
    },
    {
      title: "Externo",
      items: [
        { id: "corte-serra-externo", label: "Corte serra", checked: true },
        { id: "outros-cortes-externo", label: "Outros cortes", checked: true },
        { id: "forja-externo", label: "Forja", checked: true },
        { id: "tt-externo", label: "TT", checked: false },
        { id: "usinagem-externo", label: "Usinagem", checked: true },
        { id: "ensaios-externo", label: "Ensaios", checked: false },
        { id: "entrega-externo", label: "Entrega", checked: true },
      ],
    },
  ])

  const handleCheckboxChange = (sectionIndex: number, itemIndex: number) => {
    setSections(prevSections => {
      const newSections = [...prevSections]
      newSections[sectionIndex] = {
        ...newSections[sectionIndex],
        items: [...newSections[sectionIndex].items]
      }
      newSections[sectionIndex].items[itemIndex] = {
        ...newSections[sectionIndex].items[itemIndex],
        checked: !newSections[sectionIndex].items[itemIndex].checked
      }
      return newSections
    })
  }
  
  return(
    <>
      <CollapsibleHeader onClick={() => setIsDetailsOpen(!isDetailsOpen)}>
        <Title>Prazos</Title>
        <Button>
          {isDetailsOpen ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </Button>
      </CollapsibleHeader>
      {isDetailsOpen && 
        <FormGrid style={{ marginTop: '16px' }}>
        {sections.map((section, sectionIndex) => (
          <InternalOrExternalCard key={section.title}>
            <CardTitle>{section.title}</CardTitle>
            <CardContent>
              {section.items.map((item, itemIndex) => (
                <React.Fragment key={item.id}>
                  <ItemContainer>
                    <CheckboxContainer
                      checked={item.checked}
                      onClick={() => handleCheckboxChange(sectionIndex, itemIndex)}
                    >
                      {item.checked && <Check size={14} color="white" />}
                    </CheckboxContainer>
                    <Label onClick={() => handleCheckboxChange(sectionIndex, itemIndex)}>
                      {item.label}
                    </Label>
                    <InputContainer>
                      <Input placeholder="Value" />
                    </InputContainer>
                  </ItemContainer>
                  {itemIndex < section.items.length - 1 && <Separator margin="10px 0" />}
                </React.Fragment>
              ))}
            </CardContent>
          </InternalOrExternalCard>
        ))}
        </FormGrid>
      }
    </>
  )
}

export default DeadlinesSection